<style scoped>
.content-wrapper .content{
	padding-top: 95px;
}
.round{
	border-radius: 50%;
}
.el-button--primary>span>a{
	color: #fff;
}

.el-button--info {
    box-shadow: 0 1px 7px rgba(0,0,0,.05);
    border: 1px solid rgba(0,0,0,.04)!important;
    padding: 10px;
    background-color: white;
    color:black;
}
.el-button--info:hover {
    box-shadow: 0 1px 40px rgba(0,0,0,.05);
    border: 1px solid rgba(0,0,0,.04)!important;
    padding: 10px;
    background-color: white;
    color:black;
}

.notes-box{
	box-shadow: 0 1px 7px rgba(0,0,0,.05);
    border: 1px solid rgba(0,0,0,.04)!important;
    padding: 6px 6px 6px 6px;
    border-radius: 50%;
}

.notes-box:hover{
	box-shadow: 0 1px 7px rgba(0,0,0,.05);
    border: 1px solid rgba(0,0,0,.04)!important;
    padding: 6px 6px 6px 6px;
    border-radius: 50%;
}

.domain-name{
	display: block;
	line-height: 1;
	font-weight: bold;
}
.publisher-name{
	font-size: 12px;
    float: left;
    margin-left: 0px;
    padding: 0 10px;
    border-radius: 20px;
    line-height: 1;
    margin-top: 6px;
    text-transform: uppercase;
}
.bucket-list{
	display: block;
    padding: 0;
    margin: 0;
    list-style: none;
    white-space: nowrap;
    overflow: auto;
}
.bucket-list li{
	float: left;
	margin-right: 10px;
}
.bucket-list li:last-child{
	margin-right: 0
}
.buckets{
	overflow: auto;
}
.active-button{
	padding: 3px;
}

.box-header .box-title {
    display: inline-block;
    font-size: 15px;
    padding: 10px;
    line-height: 1;
    color: black;
}

</style>
<template>
	<!-- <transition name="el-zoom-in-top"> -->
	<div class="content-wrapper">
		<section class="content">
			<div class="box">
				<div class="box-header with-border">
					<h3 class="box-title">DFP Settings</h3>
					<button class="el-button el-button--info pull-right" @click="getNetworks()">
						<i class="ti-reload" style="font-size: 14px;"></i> Refresh Networks
					</button>
				</div>
				<div class="box-body">
					<el-table :data="networks" style="width: 100%;border-spacing: 0;" v-loading="loading">

						<el-table-column label="" width="50">

							<template slot-scope="scope">
								<div class="text-center">
									<img class="round" width="30" height="30" :avatar="`${scope.row.display_name}`">
								</div>
							</template>

						</el-table-column>

						<el-table-column class="col-md-4" label="" prop="name">

							<template slot-scope="props">
								<router-link :to="`/admin/edit-dfp/${props.row.id}`" class="">
									<span class="domain-name">{{`${props.row.display_name} (${props.row.network_code})`}}</span>
								</router-link>
								<div class = "publisher-name">Publisher: {{`${(props.row.publisher) ? (props.row.publisher.name) : 'Automatad'}`}}</div>
							</template>
							<div>
									<el-tag size="mini">Mini</el-tag>
								</div>

						</el-table-column>

						<el-table-column align="center" class="col-md-4">

							<template slot-scope="props">
								<el-button v-if="props.row.hb_setup_done === true" type="success" icon="el-icon-circle-check" class="active-button">Active</el-button>

								<el-button v-else-if="props.row.hb_setup_initiated === true" type="warning" icon="el-icon-loading" class="active-button">DFP task Initiated</el-button>

								<el-button v-else type="danger" icon="el-icon-error" class="active-button">Not active</el-button>
							</template>

						</el-table-column>

						<el-table-column align="center" class="col-md-4">

							<template slot-scope="props">
								<el-button class = "notes-box" @click = "refreshNetworkList(props.row.network_code)" data-toggle="tooltip" data-placement="top"  title="Refresh Child Networks" type="text" size="small">
									<span>
									<svg aria-hidden="true" width="16px" height="16px" data-prefix="far" data-icon="sync" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" class="svg-inline--fa fa-sync fa-w-16 fa-2x"><path fill="currentColor" d="M500 8h-27.711c-6.739 0-12.157 5.548-11.997 12.286l2.347 98.575C418.212 52.043 342.256 8 256 8 134.813 8 33.933 94.924 12.296 209.824 10.908 217.193 16.604 224 24.103 224h28.576c5.674 0 10.542-3.982 11.737-9.529C83.441 126.128 161.917 60 256 60c79.545 0 147.942 47.282 178.676 115.302l-126.39-3.009c-6.737-.16-12.286 5.257-12.286 11.997V212c0 6.627 5.373 12 12 12h192c6.627 0 12-5.373 12-12V20c0-6.627-5.373-12-12-12zm-12.103 280h-28.576c-5.674 0-10.542 3.982-11.737 9.529C428.559 385.872 350.083 452 256 452c-79.546 0-147.942-47.282-178.676-115.302l126.39 3.009c6.737.16 12.286-5.257 12.286-11.997V300c0-6.627-5.373-12-12-12H12c-6.627 0-12 5.373-12 12v192c0 6.627 5.373 12 12 12h27.711c6.739 0 12.157-5.548 11.997-12.286l-2.347-98.575C93.788 459.957 169.744 504 256 504c121.187 0 222.067-86.924 243.704-201.824 1.388-7.369-4.308-14.176-11.807-14.176z" class=""></path></svg>
								</span>
							</el-button>
							</template>

						</el-table-column>

						<el-table-column align="center" class="col-md-2">

							<template slot-scope="props">
								<el-button class = "notes-box" @click = "syncAdUnits(`${props.row.dfp.id}` , `${props.row.id}`)" data-toggle="tooltip" data-placement="top"  title="Sync AdUnits" type="text" size="small">
									<span>
									<svg aria-hidden="true" width="16px" height="16px" data-prefix="far" data-icon="sync" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" class="svg-inline--fa fa-sync fa-w-16 fa-2x"><path fill="currentColor" d="M500 8h-27.711c-6.739 0-12.157 5.548-11.997 12.286l2.347 98.575C418.212 52.043 342.256 8 256 8 134.813 8 33.933 94.924 12.296 209.824 10.908 217.193 16.604 224 24.103 224h28.576c5.674 0 10.542-3.982 11.737-9.529C83.441 126.128 161.917 60 256 60c79.545 0 147.942 47.282 178.676 115.302l-126.39-3.009c-6.737-.16-12.286 5.257-12.286 11.997V212c0 6.627 5.373 12 12 12h192c6.627 0 12-5.373 12-12V20c0-6.627-5.373-12-12-12zm-12.103 280h-28.576c-5.674 0-10.542 3.982-11.737 9.529C428.559 385.872 350.083 452 256 452c-79.546 0-147.942-47.282-178.676-115.302l126.39 3.009c6.737.16 12.286-5.257 12.286-11.997V300c0-6.627-5.373-12-12-12H12c-6.627 0-12 5.373-12 12v192c0 6.627 5.373 12 12 12h27.711c6.739 0 12.157-5.548 11.997-12.286l-2.347-98.575C93.788 459.957 169.744 504 256 504c121.187 0 222.067-86.924 243.704-201.824 1.388-7.369-4.308-14.176-11.807-14.176z" class=""></path></svg>
								</span>
							</el-button>								
							</template>

						</el-table-column>

						

						<el-table-column align="center" class="col-md-4" label="" prop="settings">

							<template slot-scope="props">
							<router-link :to="`/admin/edit-dfp/${props.row.id}`" class="pull-right">
								<el-button plain icon="el-icon-setting">Prebid Settings</el-button>
							</router-link>
						</template>

						</el-table-column>

					</el-table>
				</div>
			</div>
		</section>
	</div>
	<!-- </transition> -->
</template>
<script type="text/javascript">
	import axios from 'axios';
	import LetterAvatar from '../../../../static/plugins/letterAvatar.js'
	export default {
		data() {
			return {
				// bucketStyle: {
				// 	width: () +'px'
				// }
				networks: [],
				loading: true
			};
		},
		created: function(){
			axios.all([
				axios.get(BASE_URL + 'v1/dfp_accounts/')
			])
			.then(axios.spread( response =>  {
				console.log(response.data);
				for(let i=0;i<response.data.length;i++){
					console.log(response.data[i].networks);
					this.networks = this.networks.concat(response.data[i].networks);
				}
				console.log(this.networks);
				this.loading = false;
				// console.log(LetterAvatar);
				window.setTimeout(function(){
					LetterAvatar.transform();
				});
			}));
		},
		methods : {
			syncAdUnits: function(a, b){
				axios.get(BASE_URL + 'v1/dfp_ad_units_sync/'+a+'/network_id/'+b+'/', {
      			})
		      .then(response => {
		        console.log(response)

		        })
		      .catch(error => {

		      })
			},
			refreshNetworkList(ntwrk_code){
				axios.post(BASE_URL + 'v1/child-dfp-network-sync/', {
    				"network_code" : ntwrk_code
				})
		      .then(response => {
		        console.log(response)
				this.$notify({
					title: 'Success',
					message: 'The networks will be updated in some time',
					type: 'success'
				});
				setTimeout(() => {
					window.location.reload();
				}, 5000);

		        })
		      .catch(error => {

		      })
			},
			getNetworks(){
				console.log('Upate all networks');
				axios.get(BASE_URL + 'v1/dfp-sync/', {
				})
				.then(response => {
		        console.log(response);
		        this.$notify({
					title: 'Success',
					message: 'The networks will be updated in some time',
					type: 'success'
				});
				setTimeout(() => {
					window.location.reload();
				}, 5000);

		        })
		      .catch(error => {
		      	console.error(error);
		      	this.$notify({
					title: 'Error',
					message: 'Problem accessing DFP',
					type: 'error'
				});
		      })
			}
		}
	};
</script>


// WEBPACK FOOTER //
// DfpSettings.vue?284da51a